import { StandardEvents } from '@shopify/events';

let cartRevision = 0;

function isCartCount(value) {
  return Number.isInteger(value) && value >= 0;
}

function setCartCount(value, announce = true) {
  if (!isCartCount(value)) return;
  document.querySelectorAll('[data-cmj-shared-header]').forEach((header) => {
    const count = header.querySelector('[data-cmj-cart-count]');
    const changed = count?.textContent !== String(value);
    if (count) count.textContent = String(value);
    const template = value === 1 ? header.dataset.cartLabelOne : header.dataset.cartLabelOther;
    const label = template?.replaceAll('[count]', String(value)) || `${header.dataset.cartLabel}: ${value}`;
    const link = header.querySelector('[data-cmj-cart-link]');
    if (link) link.setAttribute('aria-label', label);
    const status = header.querySelector('[data-cmj-cart-status]');
    if (announce && changed && status) status.textContent = label;
  });
}

async function refreshCartCount(announce, revision) {
  const header = document.querySelector('[data-cmj-shared-header]');
  if (!header?.dataset.cartUrl) return;
  try {
    const url = new URL(header.dataset.cartUrl, window.location.origin);
    if (url.origin !== window.location.origin) return;
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    if (revision === cartRevision) setCartCount(cart.item_count, announce);
  } catch (_) { /* Preserve the confirmed count when the refresh fails. */ }
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (!event.promise) return;
  const revision = ++cartRevision;
  event.promise.then(({ cart }) => {
    if (revision !== cartRevision) return;
    if (isCartCount(cart?.totalQuantity)) {
      setCartCount(cart.totalQuantity);
    } else {
      return refreshCartCount(true, revision);
    }
  }).catch(() => { /* Keep the last confirmed count when a cart mutation fails. */ });
});

window.addEventListener('pageshow', (event) => {
  const navigation = window.performance?.getEntriesByType?.('navigation')?.[0];
  const restored = event.persisted || (navigation?.entryType === 'navigation' && navigation.type === 'back_forward');
  if (!restored) return;
  refreshCartCount(false, ++cartRevision);
});

